import { styled } from 'stitches.config'

export const FivePoundRoot = styled('div', {
  backgroundColor: '$accent-white',
  width: '100%',
  position: 'relative',
  '@bp2': {},

  '& strong': {
    fontWeight: '$semiBold'
  }
})

export const SectionTitle = styled('h2',{
  color: '$primary-500',
  fontWeight: '$semiBold',
  fontSize: '$h2',
  letterSpacing: '1px',
  textAlign: 'center',
  lineHeight: '$h1',

  '@bp3': {
      fontSize: '$h1',
      textAlign: 'left',
  },

  variants: {
      align: {
          'center': {
              textAlign: 'center',
              '@bp3': {textAlign: 'center'}
          }
      }
  }
})